import { motion } from "framer-motion";
import { Reveal, SectionLabel, EASE } from "./Reveal";

const CHAIN = [
  { name: "CONCEPT", note: "The idea, the cuisine, the promise" },
  { name: "MENU", note: "What you sell defines what you build" },
  { name: "KITCHEN", note: "Space, stations and equipment follow the menu" },
  { name: "PEOPLE", note: "Manpower is a function of complexity and volume" },
  { name: "OPERATIONS", note: "Workflow turns capacity into consistency" },
  { name: "SCALE", note: "Systems that replicate are systems that grow" },
];

const BigIdea = () => (
  <section id="big-idea" className="relative bg-white py-28 lg:py-40" data-testid="big-idea-section">
    <div className="max-w-[1440px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-16">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <Reveal><SectionLabel>The Big Idea — 01</SectionLabel></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display font-semibold text-3xl lg:text-5xl leading-[1.08] tracking-tight text-ink" data-testid="big-idea-headline">
              A great food brand needs more than a great recipe.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 text-ink/55 text-base lg:text-lg leading-relaxed max-w-md">
              Behind every successful food brand is a kitchen that can deliver the menu,
              the volume, the consistency and the economics.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="mt-10 border-l-2 border-skope pl-5 font-mono text-[11px] tracking-[0.2em] text-ink/40 uppercase leading-loose">
              The kitchen is not just a physical space.<br />
              <span className="text-skope">It is the operating system behind the food brand.</span>
            </div>
          </Reveal>
        </div>
      </div>

      <div className="lg:col-span-7 relative">
        <div className="absolute left-[7px] lg:left-[9px] top-2 bottom-2 w-px bg-ink/10" aria-hidden="true" />
        {CHAIN.map((step, i) => (
          <div key={step.name} className="relative pl-12 lg:pl-16 pb-14 last:pb-0">
            <motion.span
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, ease: EASE }}
              className="absolute left-0 top-2 w-[15px] h-[15px] lg:w-[19px] lg:h-[19px] rounded-full border border-skope bg-white flex items-center justify-center"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-skope" />
            </motion.span>
            <Reveal delay={0.05 * i}>
              <div className="group flex flex-col lg:flex-row lg:items-baseline gap-2 lg:gap-8" data-testid={`chain-step-${step.name.toLowerCase()}`}>
                <span className="font-mono text-xs text-skope/70">0{i + 1}</span>
                <h3 className="font-display font-bold text-4xl lg:text-6xl tracking-tight text-ink/90 group-hover:text-skope transition-colors duration-500">
                  {step.name}
                </h3>
                <p className="font-mono text-[11px] tracking-[0.15em] text-ink/35 uppercase lg:ml-auto lg:text-right max-w-[220px]">
                  {step.note}
                </p>
              </div>
            </Reveal>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default BigIdea;
